export default "<a class=\"dropdown-item fw-500 pt-3 pb-3\" (click)=\"logout()\">\r\n  <span >Cerrar Sesión</span>\r\n</a>\r\n"